export const environment = {
  production: false,
  applicationServerPublicKey: '',
  server: 'https://api.polywinegypt.com',
  apiUrl: 'https://api.polywinegypt.com/api',
  attachmentsUrl: 'https://api.polywinegypt.com/',
  ImgUrl: 'https://api.polywinegypt.com',
  staticFileUrl: ''
};
